module.exports = __webpack_public_path__ + "static/media/seven.2fa6bd92.JPG";